<template>
  <div>
    <Manpowermenubar_govem />

    <v-container fluid class="pa-6">
      <!-- Main Card -->
      <v-card class="elevation-4" style="border-radius: 16px; overflow: hidden">
        <!-- Header with Icon -->
        <div class="header-gradient pa-8">
          <v-row align="center">
            <v-col cols="auto">
              <div class="icon-circle">
                <v-icon size="64" color="white">
                  mdi-calendar-check
                </v-icon>
              </div>
            </v-col>
            <v-col>
              <h2 class="font-weight-bold white--text mb-2">
                สถานศึกษา รายงานการบริหารงานอัตรากำลัง
              </h2>
              <p class=" white--text opacity-90">
                ตำแหน่ง พนักงานราชการ - ติดตามและจัดการกำหนดการอัตรากำลัง
              </p>
            </v-col>
          </v-row>
        </div>

        <!-- Content Section -->
        <v-container fluid class="pa-8">
          <v-fade-transition>
            <div v-if="loading" class="text-center py-12">
              <v-progress-circular
                indeterminate
                color="primary"
                :width="4"
                :size="60"
              />
              <p class="mt-4 text-body1">กำลังโหลดข้อมูล...</p>
            </div>

            <div v-else>           
              <!-- Main Component -->
              <v-card
                class="elevation-2"
                style="border-radius: 12px"
              >
                <v-card-title class="pb-4">
                  <v-icon small class="mr-2">mdi-clipboard-list</v-icon>
                  รายละเอียดการจัดการกำหนดการ
                </v-card-title>
                <v-divider />
                <v-card-text class="pa-6">
                  <PeriodCollege_govem_id
                    :period_college_id="period_college_id"
                  />
                </v-card-text>
              </v-card>

              <!-- Additional Info Section -->
              <v-row class="mt-8">
                <v-col cols="12">
                  <v-card
                    class="elevation-1"
                    style="border-radius: 12px; background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)"
                  >
                    <v-card-text class="pa-6">
                      <v-row>
                        <v-col cols="12" md="4">
                          <div class="text-center">
                            <v-icon
                              color="primary"
                              size="48"
                              class="mb-2"
                            >
                              mdi-file-document-multiple
                            </v-icon>
                            <p class="text-body2 font-weight-bold mb-1">
                              รายงานประจำวัน
                            </p>
                            <p class="text-caption text-grey">
                              ติดตามรายงานการบริหารอัตรากำลัง
                            </p>
                          </div>
                        </v-col>

                        <v-col cols="12" md="4">
                          <div class="text-center">
                            <v-icon
                              color="success"
                              size="48"
                              class="mb-2"
                            >
                              mdi-check-all
                            </v-icon>
                            <p class="text-body2 font-weight-bold mb-1">
                              การยืนยันข้อมูล
                            </p>
                            <p class="text-caption text-grey">
                              ตรวจสอบและยืนยันข้อมูลกำลัง
                            </p>
                          </div>
                        </v-col>

                        <v-col cols="12" md="4">
                          <div class="text-center">
                            <v-icon
                              color="warning"
                              size="48"
                              class="mb-2"
                            >
                              mdi-calendar-range
                            </v-icon>
                            <p class="text-body2 font-weight-bold mb-1">
                              การจัดการกำหนดการ
                            </p>
                            <p class="text-caption text-grey">
                              กำหนดเวลาการรายงานตามปฏิทิน
                            </p>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-fade-transition>
        </v-container>
      </v-card>

      <!-- Footer Info -->
      <v-row class="mt-8">
        <v-col cols="12">
          <v-alert
            type="info"
            outlined
            rounded
            color="info"
            icon="mdi-information-outline"
          >
            <strong>หมายเหตุ:</strong> ระบบนี้ใช้สำหรับจัดการและติดตามการรายงานข้อมูลการบริหารงานอัตรากำลัง ตำแหน่ง พนักงานราชการ
            ของสถานศึกษาในแต่ละช่วงการศึกษา สำหรับข้อมูลเพิ่มเติม โปรดติดต่อหน่วยงานสูงต่อ
          </v-alert>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import Manpowermenubar_govem from "../../../components/admin/manpowermenubar_govem.vue";
import PeriodCollege_govem_id from "../../../components/admin/periodCollege_govem_id.vue";

export default {
  name: "GovernmentPeriodCollegeAdmin",

  components: {
    Manpowermenubar_govem,
    PeriodCollege_govem_id
  },

  data() {
    return {
      loading: true,
      ApiKey: "HRvec2021",
      user: [],
      period_college_id: "80104"
    };
  },

  async mounted() {
    await this.userQueryAll();
  },

  methods: {
    async userQueryAll() {
      try {
        let userSession = JSON.parse(sessionStorage.getItem("user")) || {};
        
        const result = await this.$http.post("user.php", {
          ApiKey: this.ApiKey,
          user_ID: userSession.user_ID
        });

        this.user = result.data;

        // Simulate loading delay for smooth transition
        setTimeout(() => {
          this.loading = false;
        }, 500);
      } catch (error) {
        console.error("Error loading user data:", error);
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.government-period-admin {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 20px 0;
}

.header-gradient {
  background: linear-gradient(135deg, #1976d2 0%, #1565c0 50%, #0d47a1 100%);
  box-shadow: 0 8px 20px rgba(25, 118, 210, 0.3);
}

.icon-circle {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(10px);
  flex-shrink: 0;
}

.info-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.1) !important;
  }
}

.opacity-90 {
  opacity: 0.9;
}

::v-deep .v-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08) !important;
  }
}

::v-deep .v-alert {
  border-radius: 12px !important;
  background: linear-gradient(135deg, rgba(33, 150, 243, 0.05) 0%, rgba(33, 150, 243, 0.02) 100%);
}

@media (max-width: 960px) {
  .header-gradient {
    padding: 24px !important;
  }

  .icon-circle {
    width: 72px;
    height: 72px;
  }
}
</style>